import React from 'react';

import { observer } from 'mobx-react-lite';
import { TeamType } from 'stores/team_store';
import useStores from 'hooks/useStores';


type TeamContextType = {
    fetchMyTeam: (identity: string) => Promise<TeamType | null>;
    getTeam: (uuid: string) => TeamType | null;

    // create one
    createTeam: (identity: string, name: string) => Promise<TeamType|null>;

    // Contains all known Team items
    items: TeamType[];
}

export const TeamContext = React.createContext<TeamContextType>({
    createTeam: () => { throw 'Not Implemented, createTeam' },
    fetchMyTeam: () => { throw 'Not Implemented, fetchMyTeam' },
    getTeam: () => { throw 'Not Implemented, getTeam' },
    items: [] as TeamType[],
});


export const TeamProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { teamStore } = useStores();

    const fetchMyTeam = async (identity: string) => {
        return teamStore.fetchMyTeam(identity);
    };

    const getTeam = (uuid: string) => {
        return teamStore.items.find((item) => item.uuid === uuid) || null;
    };


    const createTeam = async (identity: string, name: string) => {
        return teamStore.createTeam(identity, name)
            .then((newTeam: TeamType | null) => {
                return newTeam;
            });
    };

    const data = {
        fetchMyTeam,
        getTeam,
        createTeam,
        items: teamStore.items
    };

    return (
        <TeamContext.Provider value={data}>{ children }</TeamContext.Provider>
    );

});
